const ConferenceUserAssignemtKeys = {
  all: ['ConferenceUserAssignment'],
  list: () => [...ConferenceUserAssignemtKeys.all, 'list'],
  details: () => [...ConferenceUserAssignemtKeys.all, 'detail'],
  detail: (id: string) => [...ConferenceUserAssignemtKeys.details(), id],
} as const;

export { ConferenceUserAssignemtKeys };
